import { styledOmitCustomProps, Typography, TypographyProps } from '@braskai/ui-kit';

import { css, styled } from '@mui/material';

import { NativeVideoPlayer } from '@/shared/ui/NativeVideoPlayer';

// Redesigned trial banners use one fixed-height media box so the modal keeps a stable
// height across features and doesn't jump when the image finishes loading.
const COVER_MEDIA_HEIGHT = 200;

type TSImageProps = {
  $isCover?: boolean;
  $isGif?: boolean;
} & TypographyProps;

export const SImage = styled(
  'img',
  styledOmitCustomProps,
)<TSImageProps>(
  ({ $isCover, $isGif, theme }) => css`
    width: 100%;
    border-radius: 12px;
    border: ${$isGif ? `1px solid ${theme.palette.grey[200]}` : 'none'};
    ${$isCover &&
    css`
      height: ${COVER_MEDIA_HEIGHT}px;
      object-fit: cover;
    `}
  `,
);

export const SNativeVideoPlayer = styled(
  NativeVideoPlayer,
  styledOmitCustomProps,
)<{ $isCover?: boolean }>(
  ({ $isCover }) => css`
    max-height: 243px;
    ${$isCover &&
    css`
      border-radius: 12px;
      height: ${COVER_MEDIA_HEIGHT}px;
      max-height: ${COVER_MEDIA_HEIGHT}px;
      object-fit: cover;
      width: 100%;
    `}
  `,
);

type TSDescriptionTextProps = {
  $isBold?: boolean;
  $isGray?: boolean;
} & TypographyProps;

export const SDescriptionText = styled(
  Typography,
  styledOmitCustomProps,
)<TSDescriptionTextProps>(
  ({ $isGray, $isBold, theme }) => css`
    display: inline;
    color: ${$isGray ? theme.palette.grey[400] : theme.palette.grey[700]};
    font-weight: ${$isBold ? 500 : 'inherit'};
  `,
);
